var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorking2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    enableBackground: "new 0 0 64 64",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    x1: 32,
    y1: 21.834,
    x2: 32,
    y2: 61.045
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    d: " M32,21.834L8.782,32.455C8.852,46.719,18.586,55.019,32,61.045"
  }), /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " 32,61.045 8.782,32.455 32,32.455  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " 24.96,17.142 15.142,26.898 32,19.303 28.789,17.142  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " 15.142,26.898 15.142,17.08 19.958,17.08 19.958,8.682 24.96,13.684 24.96,17.142  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " 19.958,8.682 28.264,8.682 28.264,13.684 24.96,13.684  "
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    x1: 28.264,
    y1: 9.655,
    x2: 30.047,
    y2: 13.684
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    x1: 28.264,
    y1: 13.684,
    x2: 28.264,
    y2: 17.142
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    d: " M32,21.834l23.218,10.621C55.147,46.719,45.413,55.019,32,61.045"
  }), /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " 32,61.045 55.218,32.455 32,32.455  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " 39.039,17.142 48.857,26.898 32,19.303 35.211,17.142  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " 48.857,26.898 48.857,17.08 44.041,17.08 44.041,8.682 39.039,13.684 39.039,17.142  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " 44.041,8.682 35.736,8.682 35.736,13.684 39.039,13.684  "
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    x1: 35.736,
    y1: 9.655,
    x2: 33.953,
    y2: 13.684
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    x1: 35.736,
    y1: 13.684,
    x2: 35.736,
    y2: 17.142
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.264,
    y: 2.955,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    width: 7.473,
    height: 5.728
  }), /*#__PURE__*/React.createElement("polyline", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    points: " 30.556,17.154 30.047,13.684 33.953,13.684 33.445,17.15  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.96,
    y: 13.684,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1C75BC",
    strokeWidth: 0.25,
    strokeMiterlimit: 2.6131,
    width: 14.079,
    height: 3.458
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorking2);
export default __webpack_public_path__ + "static/media/working2.7a52f17b49d0bdf8491327667ed8a890.svg";
export { ForwardRef as ReactComponent };